import { render, staticRenderFns } from "./SMSResend.vue?vue&type=template&id=2f65fbc8&scoped=true"
import script from "./SMSResend.vue?vue&type=script&lang=js"
export * from "./SMSResend.vue?vue&type=script&lang=js"
import style0 from "./SMSResend.vue?vue&type=style&index=0&id=2f65fbc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65fbc8",
  null
  
)

export default component.exports